import { Fragment, useState } from "react";

import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { operatorOptionMap } from "app/pages/sales-intelligence/types/commonMaps";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

import type FindAppsAdsSellersFilter from "../../../models/AdsSellersFilter/AdsSellersFilter";
import type { IAppsAdSellersFilterItem } from "../../../types/commonFiltersDto";
import { hasSameAdsSellersObject } from "../../../utils";
import InclusionAdsSellersChip from "../../InclusionAdsSellersChip/InclusionAdsSellersChip";
import AdsSellersModal from "../../modals/AdsSellersModal/AdsSellersModal";

import { StyledAdsSellersValueDivider } from "./styles";

const AppAdSellersFilterResult = ({
    filter: { options },
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<FindAppsAdsSellersFilter>) => {
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const [selectedItem, setSelectedItem] = useState<IAppsAdSellersFilterItem | null>(null);

    const handleClose = () => {
        setIsOpenModal(false);
    };

    const handleApply = (item: IAppsAdSellersFilterItem, currentSelectedItem?: IAppsAdSellersFilterItem) => {
        const adsSellersValues = (value || []).map((adsSellersItem: IAppsAdSellersFilterItem) => {
            if (currentSelectedItem && hasSameAdsSellersObject(adsSellersItem, currentSelectedItem)) {
                return item;
            }

            return adsSellersItem;
        });
        onFilterUpdate(adsSellersValues);
        setIsOpenModal(false);
    };

    const handleOnDelete = (currentSelectedItem: IAppsAdSellersFilterItem) => {
        const filteredAdsSellers = value?.filter(
            (item: IAppsAdSellersFilterItem) => !hasSameAdsSellersObject(item, currentSelectedItem),
        );
        onFilterUpdate(filteredAdsSellers && filteredAdsSellers.length > 0 ? filteredAdsSellers : undefined);
    };

    const handleOnEdit = (currentSelectedItem: IAppsAdSellersFilterItem) => {
        setSelectedItem(currentSelectedItem);
        setIsOpenModal(true);
    };

    if (is.undefined(value) || value?.length === 0) {
        return null;
    }

    return (
        <div>
            <AdsSellersModal
                isOpen={isOpenModal}
                selected={selectedItem}
                options={options}
                value={value}
                onClose={handleClose}
                onCancel={handleClose}
                onApply={handleApply}
            />

            {value.map((adSellers: IAppsAdSellersFilterItem, i) => (
                <Fragment key={`${adSellers.inclusion}-${adSellers.operator}-${adSellers.adsSellerDomainNames[0]}`}>
                    {i > 0 ? (
                        <StyledAdsSellersValueDivider>{operatorOptionMap.and}</StyledAdsSellersValueDivider>
                    ) : null}
                    <InclusionAdsSellersChip
                        item={adSellers}
                        onEdit={handleOnEdit}
                        onDelete={handleOnDelete}
                    />
                </Fragment>
            ))}
        </div>
    );
};

export default AppAdSellersFilterResult;
